import {Component, signal} from '@angular/core';
import {Modal} from '../modal/modal';
import {ButtonComponent} from '../button/button.component';

export type DialogType = 'alert' | 'confirm';

export interface DialogConfig {
  type: DialogType;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-dialog',
  imports: [
    Modal,
    ButtonComponent
  ],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css'
})
export class DialogComponent {
  isOpen = signal(false);
  config = signal<DialogConfig>({
    type: 'alert',
    title: '',
    message: '',
    confirmText: 'OK',
    cancelText: 'Cancel'
  });

  private resolvePromise?: (value: boolean) => void;

  open(config: DialogConfig): Promise<boolean> {
    this.config.set({
      confirmText: 'OK',
      cancelText: 'Cancel',
      ...config
    });
    this.isOpen.set(true);

    return new Promise<boolean>((resolve) => {
      this.resolvePromise = resolve;
    });
  }

  handleConfirm() {
    this.isOpen.set(false);
    this.resolvePromise?.(true);
  }

  handleCancel() {
    this.isOpen.set(false);
    this.resolvePromise?.(false);
  }

  onClose() {
    // When modal closes via X button, treat as cancel
    this.resolvePromise?.(false);
  }
}
